export default {
    name: "ChatSendButton",
    props: {
        ariaLabel: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false
        }
    },
    setup(_, { emit }) {
        const handleClick = (event) => emit('send', event);

        return {
            handleClick
        };
    }
}